const state = {
    bucketUseInformationFields: [
        {
            key: "code",
            label: "流程卡號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "furnaceCode",
            label: "爐號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "screwWeight",
            label: "重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    bucketUseInformationItem: [],
}
const getters = {
    get_bucketUseInformationFields: state => {
        return state.bucketUseInformationFields
    },
    get_bucketUseInformationItem: state => {
        return state.bucketUseInformationItem
    },
}
const actions = {
    set_bucketUseInformationFields(context, array) {
        context.commit('SET_BUCKETUSEINFORMATIONFIELDS', array);
    },
    set_bucketUseInformationItem(context, array) {
        context.commit('SET_BUCKETUSEINFORMATIONITEM', array);
    },
    clear_bucketUseInformation(context) {
        context.commit('CLEAR_BUCKETUSEINFORMATION');
    },
}
const mutations = {
    SET_BUCKETUSEINFORMATIONFIELDS(state, array) {
        state.bucketUseInformationFields = array;
    },
    SET_BUCKETUSEINFORMATIONITEM(state, array) {
        state.bucketUseInformationItem = array;
    },
    CLEAR_BUCKETUSEINFORMATION(state) {
        state.bucketUseInformationItem = [];
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/bucketUseInformation.js